import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from '@tylertech/forge-angular';
import { Constants } from "../constants";
import { MessageResponseModel, SubscriptionModel } from '../models/view-meeting.model';
import { Subscription } from "rxjs";
import { SharedCommonService } from 'app/shared/services/shared-common.service';
import { SnackbarService } from '../services/snackbar.service';
import { GlobalConstants } from '../global-constants';
import { DataService } from 'app/core/services/data.service';
import { MeetingTypeList } from '../models/meeting-type-model.model';
import { MeetingManagerService } from '../services/meeting-manager.service';
import { MeetingMapping } from '../mapping/meeting-mapping';
import * as _ from 'lodash';

@Component({
    selector: 'appc-subscribe-dialog',
    templateUrl: './subscribe-dialog.component.html',
    styleUrls: ['./subscribe-dialog.component.scss'],
    standalone: false,
})
export class SubscribeDialogComponent implements OnInit, OnDestroy {

    meetingType: Array<MeetingTypeList> = [];
    emailSubscriptionModel: SubscriptionModel;
    private subscriptions: Subscription = new Subscription();
    
    constructor(
        public dialogConfig: DialogConfig,
        public dialogRef: DialogRef,
        public constants: Constants,
        public sharedCommonService: SharedCommonService,
        public snackbarService: SnackbarService,
        public globalConstants: GlobalConstants,
        public dataService: DataService,
        public meetingManagerService: MeetingManagerService,
        private meetingMapping: MeetingMapping,
    ) {
        
    }

    ngOnInit() {
        this.emailSubscriptionModel = new SubscriptionModel();
        this.getMeetingTypeList();
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.isFormValid) {
            const url = this.globalConstants.baseUrl + this.constants.serviceUrl.subscription.saveSubscriberInfo;
            this.subscriptions.add(this.dataService.post(url, this.emailSubscriptionModel).subscribe((response: MessageResponseModel) => {
                    this.snackbarService.showMessage(response.message || '');
                    this.onClose();
                },
                (errorObj) => { 
                    this.snackbarService.showMessage(errorObj?.error);
                }
            )
            );
        }
    }

    onMeetingTypeChange(event: CustomEvent) {
        this.emailSubscriptionModel.meetingTypeId = event.detail;
    }

    getMeetingTypeList() {
        this.meetingType = [];
        this.subscriptions.add(this.meetingManagerService.getMeetingTypeList().subscribe((res) => {
          this.meetingType = _.orderBy(this.meetingMapping.getMeetingTypeList(res), [user => user.title.toLowerCase()], ['asc']);
        }, (errorObj) => {
          this.snackbarService.showMessage(errorObj.error ? errorObj.error : this.constants.messages.error.internalServerError);
        }));
    }
    
    public get isEmailValid(): boolean {
        return this.sharedCommonService.patternmatch(
            this.emailSubscriptionModel.email,
            this.constants.emailRegex
        );
    }

    public get isFormValid(): boolean {
    return (
        this.isEmailValid &&
        (this.emailSubscriptionModel.agendaPosted ||
        this.emailSubscriptionModel.minutesPosted ||
        this.emailSubscriptionModel.videoPosted) &&
        this.emailSubscriptionModel.meetingTypeId > 0
    );
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
